import React, { useState } from 'react';
import { NORWAY_PATH, project, VIEW_W, VIEW_H } from '../config/norwayPath';

/**
 * NorwayMap — minimalistisk norgeskart-silhuett med markørprikker.
 * markers: [{ kommune, lat, lng, open_jobs }]
 */
export const NorwayMap = ({ markers = [], jobLabel, className = '', accent = '#0E7C5A', land = 'rgba(42,58,51,0.10)', pulse = true }) => {
  const [hover, setHover] = useState(null);
  const pts = markers
    .filter((m) => typeof m.lat === 'number' && typeof m.lng === 'number')
    .map((m) => ({ ...m, ...project(m.lng, m.lat) }))
    .sort((a, b) => (a.size || 9) - (b.size || 9));

  return (
    <div className={`relative ${className}`} data-testid="norway-map">
      <svg viewBox={`0 0 ${VIEW_W} ${VIEW_H}`} className="w-full h-auto" role="img" aria-label="Norgeskart med aktive kommuner">
        <path d={NORWAY_PATH} fill={land} stroke="rgba(42,58,51,0.25)" strokeWidth="1.5" />
        {pts.map((m) => {
          const r = m.size || 9;
          return (
            <g
              key={m.kommune_nr || m.id || `${m.kommune}-${m.x}-${m.y}`}
              onMouseEnter={() => setHover(m)}
              onMouseLeave={() => setHover(null)}
              style={{ cursor: 'pointer' }}
              data-testid={`map-marker-${m.kommune}`}
            >
              <circle cx={m.x} cy={m.y} r={pulse ? Math.max(r + 14, 22) : r + 5} fill="transparent" />
              {pulse && (
                <circle cx={m.x} cy={m.y} r={r + 4} fill={accent} opacity="0.25">
                  <animate attributeName="r" values={`${r + 4};${r + 15};${r + 4}`} dur="2.6s" repeatCount="indefinite" />
                  <animate attributeName="opacity" values="0.3;0.05;0.3" dur="2.6s" repeatCount="indefinite" />
                </circle>
              )}
              <circle cx={m.x} cy={m.y} r={r} fill={accent} fillOpacity={pulse ? 1 : 0.75} stroke="#FFFFFF" strokeWidth={pulse ? 3 : 1.5} />
            </g>
          );
        })}
      </svg>
      {hover && (
        <div
          className="absolute pointer-events-none z-10 -translate-x-1/2 -translate-y-full"
          style={{ left: `${(hover.x / VIEW_W) * 100}%`, top: `${(hover.y / VIEW_H) * 100 - 2}%` }}
          data-testid="map-tooltip"
        >
          <div className="rounded-md bg-white border border-ink/10 shadow-lg px-3 py-2 whitespace-nowrap">
            <div className="font-sans text-xs font-bold text-ink">{hover.kommune}</div>
            <div className="font-sans text-[11px]" style={{ color: accent }}>
              {jobLabel ? jobLabel(hover.open_jobs ?? hover.count) : (hover.open_jobs ?? hover.count)}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NorwayMap;
